// src/app/features/activeProductSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Product {
  id: string;
  name: string;
  description?: string;
  [key: string]: any;
}

interface ActiveProductState {
  activeProduct: Product | null;
}

// Load from localStorage if available
const loadActiveProductFromStorage = (): Product | null => {
  try {
    const stored = localStorage.getItem("activeProduct");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

const initialState: ActiveProductState = {
  activeProduct: loadActiveProductFromStorage(),
};

const activeProductSlice = createSlice({
  name: "activeProduct",
  initialState,
  reducers: {
    setActiveProduct: (state, action: PayloadAction<Product | null>) => {
      state.activeProduct = action.payload;
      // Persist to localStorage
      if (action.payload) {
        localStorage.setItem("activeProduct", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("activeProduct");
      }
    },
    clearActiveProduct: (state) => {
      state.activeProduct = null;
      localStorage.removeItem("activeProduct");
    },
  },
});

export const { setActiveProduct, clearActiveProduct } =
  activeProductSlice.actions;

export default activeProductSlice.reducer;
